import type { ComponentProps, FC } from 'react';

import { Search } from 'lucide-react';

import { Input } from '@shared/components/ui';
import { DismissButton } from '@shared/components/ui/custom/buttons/DismissButton';
import { cn } from '@shared/utils';

interface SearchInputProps extends ComponentProps<typeof Input> {
  wrapperClassName?: string;
  onClear?: () => void;
}

export const SearchInput: FC<SearchInputProps> = ({ className, wrapperClassName, onClear, value, ...props }) => {
  return (
    <div className={cn('relative w-full', wrapperClassName)}>
      <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-muted-foreground">
        <Search className="w-4 h-4" />
      </div>

      <Input
        name={props.name ?? 'search'}
        type="search"
        value={value}
        className={cn(
          'w-full h-12 pl-11 pr-11 rounded-lg transition-colors',
          'bg-background border-input text-foreground placeholder:text-muted-foreground',
          'hover:border-border',
          'focus-visible:ring-1 focus-visible:ring-ring focus-visible:border-ring focus-visible:ring-offset-0',
          '[&::-webkit-search-cancel-button]:appearance-none',
          className,
        )}
        {...props}
      />

      {value && String(value).length > 0 && (
        <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center justify-center">
          <DismissButton
            onClick={onClear}
            aria-label="Clear search"
            className="text-muted-foreground hover:text-foreground"
          />
        </div>
      )}
    </div>
  );
};
